import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const SecondaryCategory = () => {
  const dispatch = useDispatch();

  const secondaryCategoryOptions = useSelector(
    (state) => state.productSales.filters.secondary_categories
  );
  const selectedSecondaryCategoryOptions = useSelector(
    (state) => state.productSales.selectedFilters.secondary_categories
  );

  return (
    <MultiSelectDropdown
      options={secondaryCategoryOptions}
      selectedFilters={selectedSecondaryCategoryOptions}
      placeholder="Secondary Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updateSecondaryCategory(data))}
    />
  );
};

export default SecondaryCategory;
